import {Component, OnDestroy, OnInit} from '@angular/core';
import {ModalController, NavController} from "@ionic/angular";
import {QuizComponent} from "../quiz/quiz.component";
import {ActivitiesService} from "../../services/activities.service";
import {ActivityViewModel} from "../../services/models/activity/ActivityViewModel";
import {EventService} from "../../services/event.service";
import {PopupFailureComponent} from "../popups-tadek/popup-failure/popup-failure.component";
import {InfoActivityComponent} from "../info-activity/info-activity.component";
import {FortuneWheelComponent} from "../fortune-wheel/fortune-wheel.component";


@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
})
export class ActivityComponent implements OnInit, OnDestroy {
  currentActivity!: ActivityViewModel;
  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private activityService: ActivitiesService,
    private eventService: EventService
  ) { }

  ngOnInit() {
    this.refreshActivity();
    this.eventService.activityFinished.subscribe((data) => this.refreshActivity());
  }
  refreshActivity() {
    this.activityService.getCurrentActivity()
      .then(result => {
        this.currentActivity = result.currentActivity;
        if (result.createdActivity) {
          this.eventService.activityFinished.next(result.createdActivity);
        }
      })
      .catch(error => {
        console.error("GetCurrentActivity");
        console.error(error);
      });
  }
  async checkActivity_click() {
    // console.log(this.currentActivity);
    if (this.currentActivity.apiUrl.startsWith('/secured/quiz')) {
     await this.handleQuiz(this.currentActivity.activityUid);
    }
    if (this.currentActivity.apiUrl.startsWith('/secured/ciekawostka')) {
      await this.handleCiekawostka(this.currentActivity.activityUid);
    }
    if (this.currentActivity.apiUrl.startsWith('/secured/szczesciarz')) {
      await this.handleSzczesciarz(this.currentActivity.activityUid);
    }
    if (this.currentActivity.apiUrl.startsWith('/secured/fortune')) {
      await this.handleFortune(this.currentActivity.activityUid);
    }
  }
  async handleFortune(activityUid: string) {
    console.log(`handling fortune for activity: ${activityUid}`)
    const modal = await this.modalCtrl.create({
      component: FortuneWheelComponent,
      cssClass: 'popup-transparent',
      componentProps: {
        activityUid: activityUid
      }
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    this.eventService.activityFinished.next(data);
  }
  async handleSzczesciarz(activityUid: string) {
    const result = await this.activityService.registerActivity(activityUid);
    this.eventService.activityFinished.next(result.saveResult);
  }
  async handleCiekawostka(activityUid: string) {
    const modal = await this.modalCtrl.create({
      component: InfoActivityComponent,
      cssClass: 'popup-transparent',
      componentProps: {
        activityUid: activityUid
      }
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    this.eventService.activityFinished.next(data);
  }
  async handleQuiz(activityUid: string) {
    const modal = await this.modalCtrl.create({
      component: QuizComponent,
      cssClass: 'fullscreen',
      componentProps: {
        activityUid: activityUid
      }
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'finished') {
      if (data.IsCorrect) {
        this.eventService.activityFinished.next(data);
      } else {
        const popup = await this.modalCtrl.create({
          component: PopupFailureComponent,
          cssClass: 'popup-transparent'
        });
        await popup.present();
        this.eventService.activityFinished.next(data);
      }
    } else {
      console.log('dismissed');
    }
  }
  ngOnDestroy(): void {

  }
}
